// @flow
import React, {
  useState,
  useEffect,
  useRef,
} from 'react';
import {
  Card,
  Row,
  Col,
  Icon,
  Input,
  Select,
  DatePicker,
  Divider,
  Checkbox,
  message,
  Upload,
  Tag,
} from 'antd';
import {
  SpText,
  SpButton,
  Line,
  SpH5,
  SpError,
  SpStatusTag,
  SpWrapper1,
  SpFormWrapper1,
  SpFormWrapper2,
} from 'components/DesignKit';
import {
  MAX_AMOUNT,
  COUNTRIES,
  RATE_TYPES,
  MESSAGES,
} from 'appconstants';
import formatNumber from 'utils/formatNumber';
import getTaxAmount from 'utils/getTaxAmount';
import getDiscountOff from 'utils/getDiscountOff';
import { NOTIFICATION } from 'store/actionTypes';
import { API_END_POINTS, axiosAuthInstance, axiosEmptyInstance } from 'api';
import { validators } from 'utils/validationMessages';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment-timezone';
import getInvoiceBackground from 'utils/getInvoiceBackground';
import getInvoiceStatus from 'utils/getInvoiceStatus';
import getCountryAlpha2 from 'utils/getCountryAlpha2';
import swirepaylogo from 'components/NavIcons/swirepay';
import TimelineImg from 'components/NavIcons/Timeline';
import InvoiceTimelineBar from 'components/InvoiceTimelineBar';
import PosLine from 'imgs/line.svg';
import SelectShippingFee from 'routes/Invoices/components/NewInvoice/SelectShippingFee';
import { setNotification } from 'store/actions/notification';
import Address from './Address';
import AddNewCustomer from './AddNewCustomer';
import AddNewProduct from './AddNewProduct';
import DeleteInvoice from './DeleteInvoice';
import SelectCoupon from './SelectCoupon';
import AddCoupon from './AddNewCoupon';
import SelectTaxrate from './SelectTaxrate';
import AddTaxrate from './AddNewTax';
import PaymentConfirmation from './ConfirmationModals/PaymentConfirmation';
import AgreementConfirmation from './ConfirmationModals/AgreementConfirmation';
import AddItem from '../../../../../InventoryOrders/components/ItemsList/components/AddNewItem';

const { Option } = Select;

const dateFormat = 'MMM DD, YYYY';

const MOMENT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

type Props = {
  invoiceDetails: Object,
  selectedAccount: Object,
  history: {
    push: Function,
  },
  invoiceUpdate: Function,
  deleteInvoices: Function,
  customersList: Array<Object>,
  searchCustomers: Function,
  submitting: boolean,
  zipTag: string,
  customerAdd: Function,
  validator: boolean,
  productsList: Array<Object>,
  getProducts: Function,
  productAdd: Function,
  addedNewCustomer: Object,
  addedNewProduct: Object,
  createNewInvoice: Function,
  addNewCoupon: Function,
  getTaxes: Function,
  taxList: Array<Object>,
  addNewTaxRate: Function,
  newCoupon: Object,
  newTaxrate: Object,
  isEnableGenerationInvoiceNo: Boolean,
  getInventryItems: Function,
  inventoryItems: Array,
  modifierItemsList: Array<Object>,
  labelList: Array,
  itemsList: Array,
  addedNewItem: Object,
  addInventoryItems: Function,
};

const EditInvoice = (props: Props) => {
  const {
    invoiceDetails,
    selectedAccount,
    invoiceUpdate,
    deleteInvoices,
    customersList,
    searchCustomers,
    submitting,
    zipTag,
    customerAdd,
    validator,
    productsList,
    getProducts,
    productAdd,
    addedNewCustomer,
    addedNewProduct,
    createNewInvoice,
    addNewCoupon,
    getTaxes,
    taxList,
    addNewTaxRate,
    newCoupon,
    newTaxrate,
    isEnableGenerationInvoiceNo,
    getInventryItems,
    inventoryItems,
    modifierItemsList,
    labelList,
    itemsList,
    addedNewItem,
    addInventoryItems,
  } = props;
  const { invoiceTermsAndConditions: invoiceTermsAndConditionsDetail } = invoiceDetails;
  const [, forceUpdate] = useState();
  const [invoiceNo, setInvoiceNo] = useState(invoiceDetails.invoiceNumber);
  const [description, setDescription] = useState(invoiceDetails.description);
  const [issueDate, setIssueDate] = useState(invoiceDetails.issueDate);
  const [paymentDueDate, setPaymentDueDate] = useState(invoiceDetails?.paymentDueDate);
  const [customerName, setCustomerName] = useState(invoiceDetails.customer.name);
  const [customerId, setCustomerId] = useState(invoiceDetails && invoiceDetails.customer && invoiceDetails.customer.gid);
  const [shippingAddress, setShippingAddress] = useState(invoiceDetails.shippingAddress);
  const [shippingCntryId, setShippingCntryId] = useState(getCountryAlpha2(
    invoiceDetails.shippingAddress && invoiceDetails.shippingAddress.country ? invoiceDetails.shippingAddress.country.id : selectedAccount.country.id,
  ));
  const [billingAddress, setBillingAddress] = useState(invoiceDetails.billingAddress);
  const [billingCntryId, setBillingCntryId] = useState(getCountryAlpha2(
    invoiceDetails.billingAddress && invoiceDetails.billingAddress.country ? invoiceDetails.billingAddress.country.id : selectedAccount.country.id,
  ));
  const [notes, setNotes] = useState(invoiceDetails.customerNote);
  const [addressModal, setAddressModal] = useState(false);
  const [editAddress, setEditAddress] = useState({});
  const [addressType, setAddressType] = useState('');
  const [addressMethod, setAddressMethod] = useState('');
  const currencyType = invoiceDetails.currency.name;
  const currencyPrefix = selectedAccount && selectedAccount.currency.prefix;
  const [addCustomerModal, setAddCustomerModal] = useState(false);
  const [deleteInvoiceModal, setDeleteInvoiceModal] = useState(false);
  const [addProductModal, setAddProductModal] = useState(false);
  const [addItemModal, setAddItemModal] = useState(false);
  const [lineItemDtoList, setLineItemDtosList] = useState(invoiceDetails.invoiceLineItems);
  const [totalAmount, setTotalAmount] = useState(invoiceDetails.amount / 100);
  const [couponRedirect, setCouponRedirect] = useState(false);
  const [taxRedirect, setTaxRedirect] = useState(false);

  const [expiryDate, setExpiryDate] = useState(invoiceDetails.expiryDate ? invoiceDetails.expiryDate : null);
  const dateIssued = moment.utc(invoiceDetails.issueDate).tz(selectedAccount.timezone).format(dateFormat);
  const dateExpiry = moment.utc(invoiceDetails.expiryDate).tz(selectedAccount.timezone).format(dateFormat);

  const [daysLeft, setDaysLeft] = useState(invoiceDetails.daysUntilDue);
  const [sameAddress, setSameAddress] = useState(false);
  const [dateSelected, setDateSelected] = useState();
  const [addedCustomer, setAddedCustomer] = useState(false);
  const [addedProduct, setAddedProduct] = useState(false);
  const [addedItem, setAddedItem] = useState(false);
  const [lineItemIndex, setLineItemIndex] = useState(null);
  const [couponMsg, setCouponMsg] = useState('');
  const currencyObj = selectedAccount && selectedAccount.currency;
  const [selectCouponModal, setSelectCouponModal] = useState(false);
  const [selectTaxrateModal, setSelectTaxrateModal] = useState(false);
  const [updatedCoupon, setUpdatedCoupon] = useState(invoiceDetails.coupon ? invoiceDetails.coupon : {});
  const [addCouponModal, setAddCouponModal] = useState(false);
  const [addTaxModal, setAddTaxModal] = useState(false);
  const [allTaxes, setAllTaxes] = useState(taxList);
  const [allSelectedTaxrates, setAllSelectedTaxrates] = useState(invoiceDetails.taxAmount ? invoiceDetails.taxAmount : []);
  const typeOfCurrency = selectedAccount && selectedAccount.currency.name;
  const isIndia = (selectedAccount && selectedAccount.country && selectedAccount.country.id) === COUNTRIES.INDIA.id;
  const [shippingAmount, setShippingAmount] = useState(invoiceDetails.shippingAmount > 0 ? (invoiceDetails.shippingAmount / 100) : null);
  const [selectShippingFeeModal, setSelectedShippingFeeModal] = useState(false);
  const [partialPayment, setPartialPayment] = useState(invoiceDetails?.invoiceType === 'PARTIAL');
  const [agreementConfirmation, setAgreementConfirmation] = useState(false);
  const [initialAmount, setInitialAmount] = useState(invoiceTermsAndConditionsDetail?.initialAmount
    ? (invoiceTermsAndConditionsDetail?.initialAmount / 100).toFixed(2) : '');
  const [lateFee, setLateFee] = useState(invoiceTermsAndConditionsDetail?.lateFee ? (invoiceTermsAndConditionsDetail?.lateFee / 100).toFixed(2) : '');
  const [overdueInterest, setOverdueInterest] = useState(invoiceTermsAndConditionsDetail?.overdueInterest
    ? (invoiceTermsAndConditionsDetail?.overdueInterest).toFixed(2) : null);
  const [graceDays, setGraceDays] = useState(invoiceTermsAndConditionsDetail?.graceDays ? invoiceTermsAndConditionsDetail?.graceDays : null);
  const [paymentConfirmation, setPaymentConfirmation] = useState({ open: false, confirmation: false, method: '' });
  const legacySubscriber = selectedAccount && selectedAccount.legacySubscription;
  const isFirstRender = useRef(true);
  const [loader, setLoader] = useState(false);
  const [preview, setPreview] = useState(false);
  const [invoiceFile, setInvoiceFile] = useState(invoiceDetails?.invoiceDocument || null);
  const [fileName, setFileName] = useState();

  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      amount: {
        message: isIndia ? MAX_AMOUNT.MESSAGE_INR : MAX_AMOUNT.MESSAGE_USD,
        rule: (val) => (
          isIndia ? MAX_AMOUNT.LIMIT_INR_MIN <= Number(val && val.replace(/,/g, '')) && Number(val && val.replace(/,/g, '')) <= MAX_AMOUNT.LIMIT_INR
            : MAX_AMOUNT.LIMIT_USD_MIN <= Number(val && val.replace(/,/g, '')) && Number(val && val.replace(/,/g, '')) <= MAX_AMOUNT.LIMIT_USD),
      },
      minTenPercent: {
        message: 'Initial payment must be at least 10% of the total amount.',
        rule: (val, params) => {
          const numericVal = Number(val && val.replace(/,/g, ''));
          const totalPrice = Number(params[0]);
          return numericVal >= totalPrice * 0.1;
        },
      },
      maxTenPercent: {
        message: 'Late Fee should not be more than 10% of Total Invoice amount',
        rule: (val, params) => {
          const numericVal = Number(val && val.replace(/,/g, ''));
          const totalPrice = Number(params[0]);
          return numericVal <= totalPrice * 0.1;
        },
      },
      expiryDate: {
        message: 'Expiry Date must be greater than Due Date',
        rule: (val, params) => {
          const dueDate = params[0];
          return dueDate < val;
        },
      },
      interestIfOverdue: {
        message: 'Interest rate must not exceed 100%',
        rule: val => Number(val) <= 100,
      },
      gracePeriodRange: {
        message: 'Enter a number between 0 - 90',
        rule: (val) => {
          const num = Number(val);
          return !Number.isNaN(num) && num >= 0 && num <= 90;
        },
      },
    },
  }));

  useEffect(() => {
    setAllTaxes(taxList);
  }, [taxList]);

  useEffect(() => {
    if (newCoupon.gid && couponRedirect) {
      setUpdatedCoupon(newCoupon);
    }
  }, [newCoupon]);

  useEffect(() => {
    if (newTaxrate.gid && taxRedirect) {
      const listOfTaxes = [...allSelectedTaxrates];
      const taxRates = {};
      Object.assign(taxRates, newTaxrate);
      const taxRate = {
        taxRates,
      };
      listOfTaxes.push(taxRate);
      setAllSelectedTaxrates(listOfTaxes);
    }
  }, [newTaxrate]);

  useEffect(() => {
    if (!validator) {
      setAddCustomerModal(false);
      setAddProductModal(false);
      setDeleteInvoiceModal(false);
      setAddCouponModal(false);
      setAddTaxModal(false);
      setAddItemModal(false);
    }
  }, [validator]);

  useEffect(() => {
    if (addedCustomer && addedNewCustomer && addedNewCustomer.gid) {
      setCustomerName(addedNewCustomer.name);
      setCustomerId(addedNewCustomer.gid);
    }
  }, [addedNewCustomer]);

  useEffect(() => {
    if (addedProduct && addedNewProduct && addedNewProduct.gid) {
      const list = [...lineItemDtoList];
      const { amount } = addedNewProduct;
      list[lineItemIndex].name = addedNewProduct.name;
      list[lineItemIndex].description = addedNewProduct.name;
      list[lineItemIndex].note = addedNewProduct.note;
      list[lineItemIndex].rate = (amount / 100).toFixed(2);
      if (list[lineItemIndex].quantity) {
        list[lineItemIndex].amount = amount * parseInt(list[lineItemIndex].quantity, 10);
      }
      const amountTotal = list.reduce((total, item) => total + ((item.amount / 100)), 0);
      setTotalAmount(amountTotal);
      setLineItemDtosList(list);
    }
  }, [addedNewProduct]);

  useEffect(() => {
    if (addedItem && addedNewItem && addedNewItem.gid) {
      const list = [...lineItemDtoList];
      const { price } = addedNewItem;
      list[lineItemIndex].name = addedNewItem.name;
      list[lineItemIndex].description = addedNewItem.name;
      list[lineItemIndex].note = addedNewItem.note;
      list[lineItemIndex].rate = (price / 100).toFixed(2);
      list[lineItemIndex].itemGid = addedNewItem.gid;
      list[lineItemIndex].upfront = !addedNewItem.recurring;
      list[lineItemIndex].recurring = addedNewItem.recurring;
      list[lineItemIndex].currencyCode = currencyType;
      list[lineItemIndex].priceType = addedNewItem.priceType;
      if (list[lineItemIndex].quantity) {
        list[lineItemIndex].price = price * parseInt(list[lineItemIndex].quantity, 10);
      }
      const amountTotal = list.reduce((total, item) => total + ((item.rate * item.quantity)), 0);
      setTotalAmount(amountTotal);
      setLineItemDtosList(list);
    }
  }, [addedNewItem]);

  useEffect(() => {
    const list = [...lineItemDtoList];
    for (let i = 0; i < list.length; i += 1) {
      list[i].rate = list[i].amount && (list[i].amount / 100).toFixed(2);
      list[i].amount = list[i].amount && ((list[i].amount * list[i].quantity));
    }
    setLineItemDtosList([...list]);
  }, []);

  const getDueDate = (value) => {
    const regex = /^[0-9\b]+$/;
    if (regex.test(value)) {
      setDaysLeft(value);
      const day = moment().utc().tz(selectedAccount.timezone).startOf('day')
        .format(MOMENT_FORMAT);
      const dayIssued = moment().utc().tz(selectedAccount.timezone).startOf('day')
        .utc()
        .format(MOMENT_FORMAT);
      let dueDate;
      if (dateSelected && dateSelected !== day) {
        dueDate = moment(dateSelected).add(value, 'days');
      } else {
        dueDate = moment(day).add(value, 'days');
        setIssueDate(dayIssued);
      }
      // eslint-disable-next-line
      setPaymentDueDate(moment.utc(dueDate).tz(selectedAccount.timezone).startOf('day').utc().format(MOMENT_FORMAT));
    } else {
      setDaysLeft(null);
    }
  };

  const onIssueDateChange = (date) => {
    // eslint-disable-next-line
    const Date = moment(date).format(MOMENT_FORMAT);
    const selectedDate = moment.tz(Date, selectedAccount.timezone);
    const utcDate = selectedDate.utc().format(MOMENT_FORMAT);
    const dueDate = moment(utcDate).add(daysLeft, 'days');
    setIssueDate(utcDate);
    setDateSelected(Date);
    const dateDue = moment.tz(dueDate, selectedAccount.timezone);
    setPaymentDueDate(dateDue.utc().format(MOMENT_FORMAT));
  };

  const onExpiryDateChange = (date) => {
    // eslint-disable-next-line
    const Date = moment(date).format(MOMENT_FORMAT);
    const selectedDate = moment.tz(Date, selectedAccount.timezone);
    const utcDate = selectedDate.utc().format(MOMENT_FORMAT);
    setExpiryDate(date ? utcDate : null);
  };

  const onProductSearch = (search) => {
    getProducts(search);
  };

  const getCustomers = (customer) => {
    setCustomerName(customer[0]);
    setCustomerId(customer[1]);
  };

  const onSearch = (searchText) => {
    searchCustomers(searchText);
  };

  const updateAddress = (address: Object) => {
    const updatedAddress = {
      street: address.streetName,
      city: address.cityName,
      state: address.stateName,
      postalCode: address.zipCode,
      countryId: address.countryId,
    };
    if (address.addressType === 'Billing Address') {
      setBillingAddress(updatedAddress);
      setBillingCntryId(getCountryAlpha2(updatedAddress.countryId));
    } else if (address.addressType === 'Shipping Address') {
      setShippingAddress(updatedAddress);
      setShippingCntryId(getCountryAlpha2(updatedAddress.countryId));
    }
    setAddressModal(false);
  };

  const updateShippingFee = (shippingFee: Number) => {
    setShippingAmount(shippingFee);
    setSelectedShippingFeeModal(false);
  };
  const removeShippingFee = () => {
    setShippingAmount(null);
    simpleValidator.current.purgeFields();
  };
  const addNewCustomer = (newCustomer: Object) => {
    const {
      name,
      email,
      phoneNumber,
      taxStatus,
      taxValue,
      taxId,
      countryCode,
    } = newCustomer;
    const params = {
      name,
      phoneNumber: phoneNumber ? `${countryCode}${phoneNumber}` : null,
      email,
      taxId,
      taxStatus,
      taxValue,
    };
    customerAdd({
      params,
    });
    setAddedCustomer(true);
  };

  const addNewProduct = (newProduct: Object) => {
    const {
      productName,
      currency,
      productDescription,
      amount,
      productNotes,
    } = newProduct;

    const productAmount = amount.replace(/[. ,:-]+/g, '');

    const params = {
      name: productName,
      currencyCode: currency,
      description: productDescription,
      amount: Number(productAmount),
      note: productNotes,
      paymentMethodType: [
        'CARD',
      ],
      statementDescription: '',
    };

    productAdd({
      params,
    });
    setAddedProduct(true);
  };

  const addSelectedItem = (customer: Object) => {
    const {
      name,
      price,
      alternateName,
      onlineName,
      onlineEnabled,
      sku,
      isPos,
      priceType,
      primaryColor,
      categories,
      order,
      modifierGroups,
      isItemAvailable,
      cost,
      logoUrl,
      // eslint-disable-next-line no-shadow
      description,
      tagDetails,
      enableStock,
      enableDynamicAvailability,
      stockQuantity,
      onlineAvailability,
      posAvailability,
      shopDetails,
      isRecurring,
    } = customer;
    const totalPrice = price ? price.replace(/[^\d]/g, '') : 0;
    const totalCost = cost ? cost.replace(/[^\d]/g, '') : 0;

    const params = {
      name,
      alternateName,
      onlineName,
      onlineEnabled,
      sku,
      price: Number(totalPrice),
      hidden: !isPos,
      priceType,
      sortOrder: Number(order),
      colorCode: primaryColor,
      categoryGids: categories || null,
      shopGids: shopDetails || [],
      modifierGroupGids: modifierGroups || null,
      available: isItemAvailable,
      cost: Number(totalCost),
      imageUrl: logoUrl,
      description,
      tagGids: tagDetails || [],
      enableStock,
      enableDynamicAvailability,
      stockQuantity: Number(stockQuantity),
      onlineAvailability: Number(onlineAvailability * 100),
      posAvailability: Number(posAvailability * 100),
      recurring: isRecurring,
    };
    addInventoryItems({
      params,
    });
    setAddedItem(true);
  };

  const deleteInvoice = () => {
    deleteInvoices();
  };

  const handleChange = (e, index) => {
    const gid = e[1];
    const itemInfo = inventoryItems.filter((item) => (item.gid === gid));
    const list = [...lineItemDtoList];
    const { price, priceType } = itemInfo[0];
    list[index].name = itemInfo[0].name;
    list[index].description = itemInfo[0].name;
    list[index].note = itemInfo[0].note;
    list[index].rate = (price / 100).toFixed(2);
    list[index].itemGid = gid;
    list[index].priceType = priceType;
    if (list[index].quantity) {
      list[index].price = price * parseInt(list[index].quantity, 10);
    }
    const amountTotal = list.reduce((total, item) => total + ((item.rate * item.quantity)), 0);
    setTotalAmount(amountTotal);
    setLineItemDtosList(list);
  };

  const handleChangeProduct = (e, index) => {
    const gid = e[1];
    const productInfo = productsList.filter((item) => (item.gid === gid));
    const list = [...lineItemDtoList];
    const { amount } = productInfo[0];
    list[index].name = productInfo[0].name;
    list[index].description = productInfo[0].name;
    list[index].note = productInfo[0].note;
    list[index].rate = (amount / 100).toFixed(2);
    if (list[index].quantity) {
      list[index].amount = amount * parseInt(list[index].quantity, 10);
    }
    const amountTotal = list.reduce((total, item) => total + ((item.rate * item.quantity)), 0);
    setTotalAmount(amountTotal);
  };

  const handleRemoveClick = index => {
    const list = [...lineItemDtoList];
    list.splice(index, 1);
    const amountTotal = list.reduce((total, item) => total + (item.amount / 100), 0);
    setTotalAmount(amountTotal);
    setLineItemDtosList(list);
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.currentTarget;
    let regex;
    if (name === 'quantity') {
      regex = /^[0-9\b]+$/;
    } else if (name === 'rate') {
      regex = /^\d*\.?\d*$/;
    }
    const list = [...lineItemDtoList];
    if (regex.test(value) || value === '') {
      list[index][name] = value;
      if (name === 'quantity' && value && !list[index].rate) {
        const sum = list[index].amount / 100;
        list[index].amount = sum * parseInt(list[index][name], 10);
      } else if (name === 'quantity' && value && list[index].rate) {
        const sum = (list[index].rate).replace(/[. ,:-]+/g, '');
        list[index].amount = sum * parseInt(list[index][name], 10);
      } else if (name === 'rate' && value && list[index].quantity) {
        const sum = (list[index].rate).replace(/[. ,:-]+/g, '');
        list[index].amount = sum * parseInt(list[index].quantity, 10);
      }
    } else if (!regex.test(value) && name === 'quantity') {
      list[index][name] = '';
    } else if (!regex.test(value) && name === 'rate') {
      list[index][name] = null;
    }
    const amountTotal = list.reduce((total, item) => total + (item.amount / 100), 0);
    setTotalAmount(amountTotal);
    setLineItemDtosList(list);
  };

  const formatInputChange = (e, index) => {
    const { name, value } = e.currentTarget;
    const list = [...lineItemDtoList];
    const rateValue = parseFloat(value);
    if (Number.isInteger(rateValue)) {
      list[index][name] = parseInt(value, 10).toFixed(2);
    }
    setLineItemDtosList(list);
  };

  const handleAddClick = () => {
    getProducts();
    setLineItemDtosList([...lineItemDtoList, {
      amount: null,
      name: '',
      description: '',
      quantity: '1',
    }]);
  };

  const createInvoice = () => {
    createNewInvoice();
  };

  const fetchCustomer = (searchText) => {
    searchCustomers(searchText);
  };

  const getFinalAmount = (amount) => {
    let finalAmount;
    const listOfTaxes = [...allSelectedTaxrates];
    const taxLists = listOfTaxes.filter((item) => item.taxRates.inclusive === false);
    if (taxLists.length > 0) {
      const percentageAmount = taxLists.reduce(
        (total, item) => total + ((parseFloat(amount.replace(/,/g, '')) * item.taxRates.percentage) / 100), 0,
      );
      finalAmount = formatNumber((parseFloat(amount.replace(/,/g, '')) + percentageAmount).toFixed(2), currencyObj);
    } else {
      finalAmount = amount;
    }
    return finalAmount;
  };
  const getAmountWithShippingFee = (amount) => {
    if (shippingAmount) {
      const numericAmount = parseFloat(amount.replace(/,/g, '')) || 0;
      const numericShippingAmount = parseFloat(shippingAmount) || 0;
      const addedShippingAmount = numericAmount + numericShippingAmount;
      return addedShippingAmount.toFixed(2);
    }
    return amount;
  };
  const getTotalAmount = (value) => {
    let finalAmount;
    if (value) {
      const finalValue = parseFloat(value.replace(/,/g, ''));
      finalAmount = formatNumber((totalAmount - finalValue).toFixed(2), currencyObj);
    } else {
      finalAmount = formatNumber((totalAmount).toFixed(2), currencyObj);
    }
    return finalAmount;
  };

  const getAmountOff = (value) => {
    let amountOff;
    if (value.percentageOff) {
      const amount = (totalAmount * value.percentageOff) / 100;
      amountOff = formatNumber((amount).toFixed(2), currencyObj);
    } else if (value.amountOff) {
      amountOff = formatNumber((value.amountOff / 100).toFixed(2), currencyObj);
    }
    return amountOff;
  };

  const addCoupon = (coupon: Object) => {
    const {
      name,
      percentageOff,
      amountOff,
      validity,
      expiresAt,
      maximumRedemption,
      code,
      minimumAmount,
      promotionalRedeemed,
      promoExpiresAt,
      promotional,
      customerGid,
      validiyInMonths,
    } = coupon;
    const params = {
      active: true,
      name,
      percentageOff: (percentageOff ? parseFloat(percentageOff) : null),
      amountOff: (amountOff ? parseInt((amountOff).replace(/[_\W]+/g, ''), 10) : null),
      validity,
      expiresAt,
      maximumRedemption: (maximumRedemption ? parseInt(maximumRedemption, 10) : null),
      validiyInMonths: (validiyInMonths ? parseInt(validiyInMonths, 10) : null),
      currencyCode: typeOfCurrency,
    };
    const payload = {
      active: true,
      code,
      enabledForCheckout: true,
      expiresAt: promoExpiresAt,
      maximumRedemption: promotionalRedeemed ? parseInt(promotionalRedeemed, 10) : 0,
      minimumAmount: minimumAmount ? parseInt((minimumAmount).replace(/[_\W]+/g, ''), 10) : 0,
      minimumAmountCurrency: typeOfCurrency,
      restrictedToCustomers: [
        customerGid,
      ],
    };
    if (promotional) {
      addNewCoupon({
        params,
        payload,
      });
    } else if (!promotional) {
      addNewCoupon({
        params,
      });
    }
    setCouponRedirect(true);
  };

  const newCouponAdd = () => {
    setSelectCouponModal(false);
    setAddCouponModal(true);
  };

  const newTaxAdd = () => {
    setSelectTaxrateModal(false);
    setAddTaxModal(true);
  };

  const updateCoupon = (Coupon: Object) => {
    setUpdatedCoupon(Coupon);
    setSelectCouponModal(false);
  };

  const removeCoupon = () => {
    setUpdatedCoupon({});
    setCouponMsg('');
    simpleValidator.current.purgeFields();
  };

  const fetchTaxDetails = (searchParams) => {
    getTaxes(searchParams);
  };

  const updateTaxrate = (Taxrate: Object) => {
    const listOfTaxes = [...allSelectedTaxrates];
    listOfTaxes.push(Taxrate);
    setAllSelectedTaxrates(listOfTaxes);
    setSelectTaxrateModal(false);
  };

  const removeTax = (i) => {
    const listOfTaxes = [...allSelectedTaxrates];
    listOfTaxes.splice(i, 1);
    setAllSelectedTaxrates(listOfTaxes);
  };

  const addTaxrate = (taxRate: Object) => {
    const {
      displayName,
      jurisdiction,
      percentage,
      inclusive,
      taxDescription,
    } = taxRate;
    const params = {
      displayName,
      jurisdiction,
      percentage,
      inclusive,
      description: taxDescription,
    };
    addNewTaxRate({
      params,
    });
    setTaxRedirect(true);
  };

  const updateInvoice = (event, value, type) => {
    const finalAmount = getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon)));
    if (finalAmount <= 0) {
      simpleValidator.current.fields.coupon = false;
      setCouponMsg(validators.coupon.validCoupon);
    }
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    let billAddress = null;
    let shipAddress = null;

    const taxesList = [];
    const couponId = updatedCoupon.gid ? updatedCoupon.gid : null;
    const listOfTaxes = [...allSelectedTaxrates];
    for (let i = 0; i < listOfTaxes.length; i += 1) {
      taxesList.push(listOfTaxes[i].taxRates.gid);
    }

    if (billingAddress && billingAddress.street) {
      billAddress = {
        street: billingAddress && billingAddress.street,
        city: billingAddress && billingAddress.city,
        state: billingAddress && billingAddress.state,
        postalCode: billingAddress && billingAddress.postalCode,
        countryCode: billingAddress && billingCntryId,
      };
    }
    if (shippingAddress && shippingAddress.street) {
      shipAddress = {
        street: shippingAddress && shippingAddress.street,
        city: shippingAddress && shippingAddress.city,
        state: shippingAddress && shippingAddress.state,
        postalCode: shippingAddress && shippingAddress.postalCode,
        countryCode: shippingAddress && shippingCntryId,
      };
    }

    if (partialPayment && formValid && !paymentConfirmation?.confirmation && type !== 'PARTIAL' && value !== 'DRAFT') {
      setPaymentConfirmation({ open: true, confirmation: false, method: value });
      return;
    }

    const invoiceDtos = lineItemDtoList.map(({
      createdAt,
      currency,
      deleted,
      rate,
      gid,
      updatedAt,
      ...rest
    }) => ({ ...rest }));

    // eslint-disable-next-line
    const invoiceLineItemDtos = invoiceDtos.map((invoicesLine) => {
      return { ...invoicesLine, currencyCode: currencyType };
    });

    const itemList = [...invoiceLineItemDtos];

    for (let i = 0; i < itemList.length; i += 1) {
      itemList[i].amount /= itemList[i].quantity;
    }

    const formatToTwoDecimals = num => (Math.floor(num * 100) / 100);

    const rawShipAmount = getAmountWithShippingFee(getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon))));
    const pendingAmount = (
      Number(rawShipAmount && rawShipAmount?.replace(/,/g, '')) - Number(initialAmount && initialAmount?.replace(/,/g, ''))
    ).toFixed(2);

    const invoiceTermsAndConditions = partialPayment ? {
      initialAmount: initialAmount * 100,
      lateFee: lateFee ? lateFee * 100 : null,
      graceDays,
      pendingAmount: pendingAmount ? formatToTwoDecimals(pendingAmount * 100) : null,
      overdueInterest,
    } : null;

    const invoiceStatus = value;
    const invoiceParams = {
      currencyCode: currencyType,
      couponGid: couponId,
      customerGid: customerId,
      daysUntilDue: daysLeft,
      paymentDueDate,
      issueDate,
      expiryDate,
      amount: (totalAmount * 100),
      status: invoiceStatus,
      description,
      shippingAmount: shippingAmount !== null ? (shippingAmount * 100) : '',
      taxRates: taxesList,
      customerNote: notes,
      billingAddress: billAddress,
      shippingAddress: shipAddress,
      subscriptionGid: null,
      invoiceLineItemDtos: itemList,
      invoiceLineItems: itemList,
      invoiceTermsAndConditions,
      invoiceType: partialPayment ? 'PARTIAL' : 'REGULAR',
      invoiceDocument: invoiceFile,
    };
    const params = isEnableGenerationInvoiceNo
      ? invoiceParams
      : { invoiceNumber: invoiceNo, ...invoiceParams };

    invoiceUpdate({
      params,
    });
  };

  const uploadButton = (
    <div>
      {loader ? <Icon type="loading" />
        : (
          <SpText
            color="#279dfe"
            fontWeight="600"
            style={{ cursor: 'pointer' }}
          >
            <Icon type="upload" /> Upload Physical Invoice
          </SpText>
        )}
    </div>
  );

  const beforeUpload = (file) => {
    const isLt5M = file.size / 1024 / 1024 < 2;
    const fileType = (file.name).substring((file.name).length - 4);
    // Allowed file extensions
    const allowedExtensions = ['.pdf', '.csv', 'docx', '.jpeg', '.jpg', '.png', 'xlsx', '.doc', '.zip'];

    // Check if extension is allowed
    const isAllowed = allowedExtensions.includes(fileType);
    if (!isAllowed) {
      message.error('File format is not supported');
      return false;
    }
    if (isAllowed && !isLt5M) {
      message.error('File must smaller than 2MB!');
      return false;
    } return true;
  };

  const fileReader = async file => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsArrayBuffer(file);
  });

  const fileUpload = async (info) => {
    const { file } = info;
    try {
      setLoader(true);
      if (file) {
        const { data: { entity } } = await axiosAuthInstance.get(API_END_POINTS.UPLOAD_INVOICE);
        await axiosEmptyInstance.put(entity, await fileReader(file), { headers: { 'Content-Type': file.type } });
        const invoiceFileDetails = {
          fileUrl: entity,
          keyType: 'INVOICE_ATTACHMENT',
        };
        const { data: { entity: { fileUrl } } } = await axiosAuthInstance.post(API_END_POINTS.UPLOAD_INVOICE, invoiceFileDetails);
        setInvoiceFile(fileUrl);
        setFileName(file.name);
        setNotification({
          type: NOTIFICATION.SUCCESS,
          payload: MESSAGES.FILE_UPLOAD.SUCCESS,
        });
      }
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: MESSAGES.FILE_UPLOAD.ERROR,
      });
    } finally {
      setLoader(false);
    }
  };

  const handleUploadChange = ({ file }) => {
    if (file.status === 'uploading') {
      setLoader(true);
    }
    setPreview(<Tag color="#87d068">{file.name} - uploaded</Tag>);
  };

  const handleViewPdf = () => {
    window.open(invoiceFile, '_blank');
  };

  const getTenPercentage = () => {
    const rawAmount = getAmountWithShippingFee(getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon))));
    const finalAmount = typeof rawAmount === 'string'
      ? parseFloat(rawAmount.replace(/,/g, ''))
      : rawAmount;

    return finalAmount > 0 ? (finalAmount * 0.1).toFixed(2) : '0.00';
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setInitialAmount(getTenPercentage());
  }, [getAmountWithShippingFee(getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon)))), invoiceTermsAndConditionsDetail]);

  const rawAmount = getAmountWithShippingFee(getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon))));
  const finalAmountWithCoupon = typeof rawAmount === 'string'
    ? parseFloat(rawAmount.replace(/,/g, ''))
    : rawAmount;

  return (
    <Card>
      <Row type="flex" justify="space-between" className="my-2 mb-3 mt-2">
        <Col>
          <SpStatusTag style={{ backgroundColor: getInvoiceBackground(invoiceDetails.status), height: '21px' }}>
            {getInvoiceStatus(invoiceDetails.status)}
          </SpStatusTag>
        </Col>
        <Col>
          <SpButton
            type="secondary"
            shape="round"
            className="mr-4"
            ghost
            onClick={createInvoice}
          >
            Duplicate Invoice
          </SpButton>
          <SpButton
            type="secondary"
            shape="round"
            className="mr-4"
            ghost
            onClick={(e) => updateInvoice(e, 'DRAFT', 'REGULAR')}
          >
            Save Draft
          </SpButton>
          <SpButton
            type="secondary"
            shape="round"
            className="mr-4"
            ghost
            onClick={() => setDeleteInvoiceModal(true)}
          >
            Delete Invoice
          </SpButton>
          <SpButton
            type="primary"
            shape="round"
            className="mr-4"
            onClick={(e) => updateInvoice(e, 'ACTIVE', 'REGULAR')}
          >
            Send Invoice
          </SpButton>
        </Col>
      </Row>

      {/* ADD CUSTOMER MODAL */}
      {addCustomerModal && (
        <AddNewCustomer
          visible={addCustomerModal}
          submitting={submitting}
          close={() => setAddCustomerModal(false)}
          submit={addNewCustomer}
          selectedAccount={selectedAccount}
        />
      )}

      {/* ADDRESS MODAL */}
      {addressModal && (
        <Address
          visible={addressModal}
          submitting={submitting}
          close={() => setAddressModal(false)}
          submit={updateAddress}
          country={selectedAccount.country.name}
          cntryId={selectedAccount.country.id}
          editAddress={editAddress}
          addressType={addressType}
          addressMethod={addressMethod}
          zipTag={zipTag}
        />
      )}

      {/* ADD PRODUCT MODAL */}
      {addProductModal && (
        <AddNewProduct
          visible={addProductModal}
          submitting={submitting}
          close={() => setAddProductModal(false)}
          submit={addNewProduct}
          selectedAccount={selectedAccount}
        />
      )}

      {/* ADD ITEM MODAL */}
      {addItemModal && (
        <AddItem
          visible={addItemModal}
          submitting={submitting}
          itemsList={itemsList}
          modifierItemsList={modifierItemsList}
          labelList={labelList}
          selectedAccount={selectedAccount}
          close={() => setAddItemModal(false)}
          submit={addSelectedItem}
        />
      )}

      {/* DELETE INVOICE MODAL */}
      {deleteInvoiceModal && (
        <DeleteInvoice
          visible={deleteInvoiceModal}
          invoiceNo={invoiceNo}
          submitting={submitting}
          close={() => setDeleteInvoiceModal(false)}
          submit={deleteInvoice}
        />
      )}

      {/* SELECT COUPON MODAL */}
      {selectCouponModal && (
        <SelectCoupon
          visible={selectCouponModal}
          submitting={submitting}
          close={() => setSelectCouponModal(false)}
          submit={updateCoupon}
          newCouponAdd={newCouponAdd}
        />
      )}

      {/* ADD COUPON MODAL */}
      {addCouponModal && (
        <AddCoupon
          visible={addCouponModal}
          submitting={submitting}
          close={() => setAddCouponModal(false)}
          submit={addCoupon}
          selectedAccount={selectedAccount}
          allCustomers={customersList}
          fetchCustomer={fetchCustomer}
        />
      )}

      {/* SELECT SHIPPINFEE MODAL */}
      {selectShippingFeeModal && (
        <SelectShippingFee
          visible={selectShippingFeeModal}
          submitting={submitting}
          close={() => setSelectedShippingFeeModal(false)}
          submit={updateShippingFee}
          newTaxAdd={newTaxAdd}
          prefix={currencyPrefix}
        />
      )}

      {/* SELECT TAXRATE MODAL */}
      {selectTaxrateModal && (
        <SelectTaxrate
          visible={selectTaxrateModal}
          submitting={submitting}
          close={() => setSelectTaxrateModal(false)}
          submit={updateTaxrate}
          newTaxAdd={newTaxAdd}
        />
      )}

      {/* ADD TAX MODAL */}
      {addTaxModal && (
        <AddTaxrate
          visible={addTaxModal}
          submitting={submitting}
          close={() => setAddTaxModal(false)}
          submit={addTaxrate}
          selectedAccount={selectedAccount}
          allTaxes={allTaxes}
          fetchTaxDetails={fetchTaxDetails}
        />
      )}

      {/* CONFIRMATION MODAL */}
      {agreementConfirmation && (
        <AgreementConfirmation
          open={agreementConfirmation}
          setAgreementConfirmation={setAgreementConfirmation}
          setPartialPayment={setPartialPayment}
        />
      )}
      {paymentConfirmation?.open && (
        <PaymentConfirmation
          paymentConfirmation={paymentConfirmation}
          setPaymentConfirmation={setPaymentConfirmation}
          onConfirm={updateInvoice}
          viewDetails={{
            overdueInterest,
            initialAmount,
            lateFee,
            graceDays,
            prefix: currencyPrefix,
            totalAmount: getAmountWithShippingFee(getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon)))),
            paymentDueDate: moment.utc(paymentDueDate).tz(selectedAccount.timezone).format(dateFormat),
          }}
        />
      )}

      <Row type="flex">
        <Col span={17}>
          <SpWrapper1>
            <SpFormWrapper1>
              <Row type="flex" justify="space-between" className="my-2 mb-3 mt-2">
                <Col className="d-flex align-items-center">
                  {
                    selectedAccount && selectedAccount.largeLogo ? (
                      <img src={selectedAccount.largeLogo} alt={selectedAccount.name} style={{ width: '108px', height: '74px' }} />
                    ) : (
                      <SpText className="mr-5" fontSize="20px" fontWeight="600">{selectedAccount.name}</SpText>
                    )
                  }
                </Col>
                <Col className="d-flex">
                  <div className="mr-2 mt-3">
                    <SpText color="rgba(0, 0, 0, 0.7)">Powered by</SpText>
                  </div>
                  <Icon
                    style={{
                      fontSize: '24px',
                    }}
                    component={swirepaylogo}
                  />
                </Col>
              </Row>
              <Row type="flex" className="my-2 mb-3 mt-2">
                <Col className="d-flex" span={12}>
                  <SpText fontSize="18px" style={{ width: '40%' }}>INVOICE No.</SpText>
                  <div className="mr-5">
                    <Input
                      value={invoiceNo}
                      disabled={isEnableGenerationInvoiceNo}
                      onChange={(e) => setInvoiceNo(e.currentTarget.value)}
                    />
                  </div>
                </Col>
                <Col span={12}>
                  <SpText fontWeight="600">Due Date</SpText>
                  <div className="d-flex pt-1 pb-1 mr-5">
                    <Input
                      style={{ width: '20%' }}
                      className="pt-1 mr-2"
                      value={daysLeft && daysLeft}
                      maxlength="3"
                      onChange={(e) => getDueDate(e.currentTarget.value)}
                      onKeyPress={e => {
                        const keyCode = e.charCode || e.which;
                        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                          e.preventDefault();
                        }
                      }}
                    />
                    <SpText className="pt-1">days after issue date</SpText>
                  </div>
                  <SpError>
                    {simpleValidator.current.message('Due date', daysLeft, 'required|numeric')}
                  </SpError>
                </Col>
              </Row>
              <Row type="flex" className="my-2 mb-3 mt-2">
                <Col span={12}>
                  <div className="pt-1 pb-1"><SpText fontWeight="600">Description</SpText></div>
                  <div className="pt-1 pb-1 mr-5">
                    <Input
                      defaultValue={description}
                      onChange={(e) => setDescription(e.currentTarget.value)}
                    />
                    <SpError>
                      {simpleValidator.current.message('Description', description, 'required')}
                    </SpError>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="pt-1 pb-1"><SpText fontWeight="600">Issue Date</SpText></div>
                  <div className="pt-1 pb-1 mr-5">
                    <DatePicker
                      defaultValue={moment(dateIssued, dateFormat)}
                      format={dateFormat}
                      allowClear={false}
                      disabledDate={current => current && current < moment().subtract(1, 'days')}
                      onChange={onIssueDateChange}
                    />
                  </div>
                </Col>
              </Row>
              <Row type="flex" className="my-2 mb-3 mt-2">
                <Col span={12}>
                  <div className="pt-1 pb-1"><SpText fontWeight="600">Bill to</SpText></div>
                  <div className="pt-1 pb-1 mr-5">
                    <div onMouseDown={(e) => { e.preventDefault(); return false; }}>
                      <Select
                        value={customerName}
                        style={{ width: '100%' }}
                        showSearch
                        onSearch={onSearch}
                        onChange={(e) => getCustomers(e)}
                        dropdownRender={menu => (
                          <div>
                            {menu}
                            <Divider style={{ margin: '2px 0' }} />
                            <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 3 }}>
                              <span
                                style={{
                                  flex: 'none',
                                  padding: '8px',
                                  display: 'block',
                                  cursor: 'pointer',
                                  color: '#279dfe',
                                }}
                                onClick={() => setAddCustomerModal(true)}
                              >
                                <Icon type="plus-circle" />&nbsp;Add New Customer
                              </span>
                            </div>
                          </div>
                        )}
                      >
                        {customersList.map((item) => (
                          <Option key={item.gid} value={[item.name, item.gid]}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                      <SpError>
                        {simpleValidator.current.message('Customer', customerName, 'required')}
                      </SpError>
                    </div>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="pt-1 pb-1"><SpText fontWeight="600">Expiry Date</SpText></div>
                  <div className="pt-1 pb-1 mr-5">
                    <DatePicker
                      defaultValue={moment(dateExpiry, dateFormat)}
                      format={dateFormat}
                      allowClear={false}
                      disabledDate={current => current && current < moment().subtract(1, 'days')}
                      onChange={onExpiryDateChange}
                    />
                  </div>
                  <SpError>
                    {simpleValidator.current.message('Expiry Date', expiryDate, partialPayment ? `required|expiryDate:${paymentDueDate}` : '')}
                  </SpError>
                </Col>
              </Row>
              <Row type="flex" className="my-2 mb-3 mt-2">
                <Col span={12}>
                  <div className="d-flex pt-1 pb-1">
                    <div className="mr-3"><SpText fontWeight="600">Billing Address</SpText></div>
                    <div className="d-flex ml-1">
                      {billingAddress && billingAddress.street && (
                        <>
                          <SpText
                            color="#279dfe"
                            fontWeight="600"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setAddressModal(true);
                              setEditAddress(billingAddress);
                              setAddressType('Billing Address');
                              setAddressMethod('Update');
                            }}
                          >
                            Update
                          </SpText>
                          <span className="mr-2 ml-2" style={{ fontWeight: '600' }}>|</span>
                          <SpText
                            color="#279dfe"
                            fontWeight="600"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setBillingAddress({});
                              setBillingCntryId();
                            }}
                          >
                            Remove
                          </SpText>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="pt-1 pb-1 pr-5">
                    {
                      billingAddress && billingAddress.street ? (
                        <SpText color="#434343">
                          {`${billingAddress.street}, ${billingAddress.city},
                  ${billingAddress.state} ${billingAddress.postalCode}`}
                        </SpText>
                      ) : (
                        <SpText
                          color="#279dfe"
                          fontWeight="600"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            setAddressModal(true);
                            setEditAddress(billingAddress);
                            setAddressType('Billing Address');
                            setAddressMethod('Add');
                          }}
                        >
                          {'\u002B'}&nbsp;Add billing address
                        </SpText>
                      )
                    }
                  </div>
                </Col>
                <Col span={12}>
                  <div className="d-flex pt-1 pb-1">
                    <div className="mr-3"><SpText fontWeight="600">Shipping Address</SpText></div>
                    <div className="d-flex ml-1">
                      {shippingAddress && shippingAddress.street && (
                        <>
                          <SpText
                            color="#279dfe"
                            fontWeight="600"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setAddressModal(true);
                              setEditAddress(shippingAddress);
                              setAddressType('Shipping Address');
                              setAddressMethod('Update');
                            }}
                          >
                            Updatesss
                          </SpText>
                          <span className="mr-2 ml-2" style={{ fontWeight: '600' }}>|</span>
                          <SpText
                            color="#279dfe"
                            fontWeight="600"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setShippingAddress({});
                              setShippingCntryId();
                              setSameAddress(false);
                            }}
                          >
                            Remove
                          </SpText>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="pt-1 pb-1 pr-5">
                    {
                      shippingAddress && shippingAddress.street ? (
                        <SpText color="#434343">
                          {`${shippingAddress.street}, ${shippingAddress.city},
                  ${shippingAddress.state} ${shippingAddress.postalCode}`}
                        </SpText>
                      ) : (
                        <>
                          <SpText
                            color="#279dfe"
                            fontWeight="600"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setAddressModal(true);
                              setEditAddress(shippingAddress);
                              setAddressType('Shipping Address');
                              setAddressMethod('Add');
                            }}
                          >
                            {'\u002B'}&nbsp;Add shipping address
                          </SpText>
                          <div className="d-flex mt-1">
                            <Checkbox
                              checked={sameAddress}
                              className="mb-1 mr-2"
                              onChange={({ target: { checked } }) => {
                                setSameAddress(checked);
                                setShippingAddress(billingAddress);
                              }}
                            />
                            Same as the billing address
                          </div>
                        </>
                      )
                    }
                  </div>
                </Col>
              </Row>
              <Row type="flex" className="my-2 mb-3 mt-2" style={{ background: '#eeeeff', padding: '5px' }}>
                <Col span={10}>
                  <div className="pt-1 pb-1 pl-1"><SpText fontWeight="600">Description</SpText></div>
                </Col>
                <Col span={14}>
                  <Row type="flex" justify="end">
                    <Col span={6} className="pt-1 mr-3" align="center">
                      <SpText fontWeight="600" fontSize="14px">Rate</SpText>
                    </Col>
                    <Col span={6} className="pt-1 mr-3" align="center">
                      <SpText fontWeight="600" fontSize="14px">Quantity</SpText>
                    </Col>
                    <Col span={6} className="pt-1 mr-3" align="right">
                      <SpText fontWeight="600" fontSize="14px">Total</SpText>
                    </Col>
                    <Col span={2} className="pt-1" align="right" />
                  </Row>
                </Col>
              </Row>

              {/* THIS FUNCTIONALITIES IS BASED ON LEGACY SUBSCRIBER */}
              {!legacySubscriber
                ? (
                  <>
                    <Row type="flex" className="my-2 mb-3 mt-2" style={{ padding: '0 0 0 5px' }}>
                      {lineItemDtoList.map((item, i) => (
                        <>
                          <Col span={10} className="pb-1">
                            <div className="w-100 pr-3">
                              <div onMouseDown={(e) => { e.preventDefault(); return false; }}>
                                <Select
                                  value={item.name || 'Select an item'}
                                  style={{ width: '100%' }}
                                  showSearch
                                  onSearch={getInventryItems}
                                  onSelect={e => handleChange(e, i)}
                                  dropdownRender={menu => (
                                    <div>
                                      {menu}
                                      <Divider style={{ margin: '2px 0' }} />
                                      <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 3 }}>
                                        <span
                                          style={{
                                            flex: 'none',
                                            padding: '8px',
                                            display: 'block',
                                            cursor: 'pointer',
                                            color: '#279dfe',
                                          }}
                                          onClick={() => {
                                            setAddItemModal(true);
                                            setLineItemIndex(i);
                                          }}
                                        >
                                          <Icon type="plus-circle" />&nbsp;Add New Item
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                >
                                  {inventoryItems && inventoryItems.map((inventoryitem) => (
                                    <Option
                                      key={inventoryitem.gid}
                                      value={[
                                        inventoryitem.name,
                                        inventoryitem.gid,
                                        inventoryitem.price,
                                      ]}
                                    >
                                      {inventoryitem.name}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                              <SpError>
                                {simpleValidator.current.message('item', lineItemDtoList[i].name, 'required')}
                              </SpError>
                            </div>
                          </Col>
                          <Col span={14}>
                            <Row type="flex" justify="end">
                              <Col span={6} className="mr-3">
                                <Input
                                  name="rate"
                                  value={item.rate && item.rate}
                                  disabled={item.priceType !== 'VARIABLE'}
                                  placeholder="0.00"
                                  prefix={currencyPrefix}
                                  onChange={e => handleInputChange(e, i)}
                                  onBlur={e => formatInputChange(e, i)}
                                  onKeyPress={e => {
                                    const keyCode = e.charCode || e.which;
                                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                <SpError>
                                  {simpleValidator.current.message('Rate', lineItemDtoList[i].rate, 'required|amount')}
                                </SpError>
                              </Col>
                              <Col span={6} className="mr-3">
                                <Input
                                  name="quantity"
                                  value={item.quantity}
                                  onChange={e => handleInputChange(e, i)}
                                  onKeyPress={e => {
                                    const keyCode = e.charCode || e.which;
                                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                <SpError>
                                  {simpleValidator.current.message('Quantity', lineItemDtoList[i].quantity, 'required|numeric')}
                                </SpError>
                              </Col>
                              <Col span={6} className="pt-2 mr-3" align="right">
                                <SpText fontWeight="600">{currencyPrefix} {formatNumber((item.rate * item.quantity).toFixed(2), currencyObj)}</SpText>
                              </Col>
                              <Col span={2} className="pt-1" align="right">
                                {i !== 0 ? (
                                  <Icon
                                    type="minus-circle"
                                    className="mr-2 mt-1"
                                    style={{ cursor: 'pointer', color: '#ff4d50' }}
                                    onClick={() => handleRemoveClick(i)}
                                  />
                                ) : (
                                  <span className="mr-2 mt-2">&nbsp;&nbsp;&nbsp;</span>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </>
                      ))}
                    </Row>
                    <Row type="flex" className="mt-2">
                      <Col span={10}>
                        <div className="pt-1 pb-1 ml-2" style={{ cursor: 'pointer' }}>
                          <SpText
                            fontWeight="600"
                            color="#279dfe"
                            onClick={handleAddClick}
                          >
                            {'\u002B'}&nbsp; Add another item
                          </SpText>
                        </div>
                      </Col>
                      <Col span={14}>
                        <Row type="flex" justify="end" className="ml-1">
                          <Col span={12} className="pt-1 ml-5" align="left">
                            <SpText fontWeight="600" fontSize="14px">Subtotal</SpText>
                          </Col>
                          <Col span={6} className="pt-1 mr-3" align="right">
                            <SpText fontWeight="600">
                              {`${currencyPrefix} ${formatNumber((totalAmount).toFixed(2), currencyObj)}`}
                            </SpText>
                          </Col>
                          <Col span={2} className="pt-1" align="right" />
                        </Row>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row type="flex" className="my-2 mb-3 mt-2" style={{ padding: '0 0 0 5px' }}>
                      {lineItemDtoList.map((item, i) => (
                        <>
                          <Col span={10} className="pb-1">
                            <div className="w-100 pr-3">
                              <div onMouseDown={(e) => { e.preventDefault(); return false; }}>
                                <Select
                                  value={item.name || 'Select an Product'}
                                  style={{ width: '100%' }}
                                  showSearch
                                  onSearch={onProductSearch}
                                  onSelect={e => handleChangeProduct(e, i)}
                                  dropdownRender={menu => (
                                    <div>
                                      {menu}
                                      <Divider style={{ margin: '2px 0' }} />
                                      <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 3 }}>
                                        <span
                                          style={{
                                            flex: 'none',
                                            padding: '8px',
                                            display: 'block',
                                            cursor: 'pointer',
                                            color: '#279dfe',
                                          }}
                                          onClick={() => {
                                            setAddProductModal(true);
                                            setLineItemIndex(i);
                                          }}
                                        >
                                          <Icon type="plus-circle" />&nbsp;Add New Product
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                >
                                  {productsList.map((product) => (
                                    <Option
                                      key={product.gid}
                                      value={[
                                        product.name,
                                        product.gid,
                                      ]}
                                    >
                                      {product.name}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                              <SpError>
                                {simpleValidator.current.message('product', lineItemDtoList[i].name, 'required')}
                              </SpError>
                            </div>
                          </Col>
                          <Col span={14}>
                            <Row type="flex" justify="end">
                              <Col span={6} className="mr-3">
                                <Input
                                  name="rate"
                                  value={item.rate && item.rate}
                                  placeholder="0.00"
                                  prefix={currencyPrefix}
                                  onChange={e => handleInputChange(e, i)}
                                  onBlur={e => formatInputChange(e, i)}
                                  onKeyPress={e => {
                                    const keyCode = e.charCode || e.which;
                                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                <SpError>
                                  {simpleValidator.current.message('Rate', lineItemDtoList[i].rate, 'required|amount')}
                                </SpError>
                              </Col>
                              <Col span={6} className="mr-3">
                                <Input
                                  name="quantity"
                                  value={item.quantity}
                                  onChange={e => handleInputChange(e, i)}
                                  onKeyPress={e => {
                                    const keyCode = e.charCode || e.which;
                                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                <SpError>
                                  {simpleValidator.current.message('Quantity', lineItemDtoList[i].quantity, 'required|numeric')}
                                </SpError>
                              </Col>
                              <Col span={6} className="pt-2 mr-3" align="right">
                                <SpText fontWeight="600">{currencyPrefix} {formatNumber((item.rate * item.quantity).toFixed(2), currencyObj)}</SpText>
                              </Col>
                              <Col span={2} className="pt-1" align="right">
                                {i !== 0 ? (
                                  <Icon
                                    type="minus-circle"
                                    className="mr-2 mt-1"
                                    style={{ cursor: 'pointer', color: '#ff4d50' }}
                                    onClick={() => handleRemoveClick(i)}
                                  />
                                ) : (
                                  <span className="mr-2 mt-2">&nbsp;&nbsp;&nbsp;</span>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </>
                      ))}
                    </Row>
                    <Row type="flex" className="mt-2">
                      <Col span={10}>
                        <div className="pt-1 pb-1 ml-2" style={{ cursor: 'pointer' }}>
                          <SpText
                            fontWeight="600"
                            color="#279dfe"
                            onClick={handleAddClick}
                          >
                            {'\u002B'}&nbsp; Add another Product
                          </SpText>
                        </div>
                      </Col>
                      <Col span={14}>
                        <Row type="flex" justify="end" className="ml-1">
                          <Col span={12} className="pt-1 ml-5" align="left">
                            <SpText fontWeight="600" fontSize="14px">Subtotal</SpText>
                          </Col>
                          <Col span={6} className="pt-1 mr-3" align="right">
                            <SpText fontWeight="600">
                              {`${currencyPrefix} ${formatNumber((totalAmount).toFixed(2), currencyObj)}`}
                            </SpText>
                          </Col>
                          <Col span={2} className="pt-1" align="right" />
                        </Row>
                      </Col>
                    </Row>
                  </>
                )}

              <Row type="flex" justify="end" className="ml-2 mb-2">
                {updatedCoupon.gid ? (
                  <Col span={14}>
                    <Row type="flex" justify="end">
                      <Col span={12} className="pt-1 ml-3" align="left">
                        <div className="pt-1 pb-1" style={{ cursor: 'pointer' }}>
                          <SpText>
                            {updatedCoupon.name}
                          </SpText><br />
                          <SpText fontSize="12px">
                            {getDiscountOff(updatedCoupon)}
                          </SpText>
                        </div>
                        <div>
                          <SpError>
                            {couponMsg}
                          </SpError>
                        </div>
                      </Col>
                      <Col span={6} className="pt-2 mr-3" align="right">
                        <SpText fontWeight="600">({currencyPrefix} {getAmountOff(updatedCoupon)})</SpText>
                      </Col>
                      <Col span={2} className="pt-1" align="right">
                        <Icon
                          type="minus-circle"
                          className="mr-2 mt-1"
                          style={{ cursor: 'pointer', color: '#ff4d50' }}
                          onClick={removeCoupon}
                        />
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  <Col span={14}>
                    <Row type="flex" justify="end">
                      <Col span={12} className="pt-1 ml-3" align="left">
                        <div className="pt-1 pb-1" style={{ cursor: 'pointer' }}>
                          <SpText
                            fontWeight="600"
                            color="#279dfe"
                            onClick={() => setSelectCouponModal(true)}
                          >
                            Apply Coupon
                          </SpText>
                        </div>
                      </Col>
                      <Col span={8} className="pt-1 mr-3" align="right" />
                    </Row>
                  </Col>
                )}
              </Row>
              <Row type="flex" justify="end" className="ml-2">
                {
                  allSelectedTaxrates.map((item, i) => (
                    <Col span={14}>
                      <Row type="flex" justify="end">
                        <Col span={9} className="pt-1 ml-3" align="left">
                          <div className="pt-1 pb-1" style={{ cursor: 'pointer' }}>
                            <SpText>
                              {item.taxRates.displayName}
                            </SpText><br />
                            <SpText fontSize="12px">
                              {item.taxRates.inclusive ? RATE_TYPES.INCLUSIVE : RATE_TYPES.EXCLUSIVE}
                            </SpText>
                          </div>
                        </Col>
                        <Col span={3} className="pt-1" align="right">{item.taxRates.percentage} %</Col>
                        <Col span={6} className="pt-2 mr-3" align="right">
                          <SpText fontWeight="600">
                            {currencyPrefix} {getTaxAmount(item.taxRates, totalAmount, getAmountOff(updatedCoupon), selectedAccount)}
                          </SpText>
                        </Col>
                        <Col span={2} className="pt-1" align="right">
                          <Icon
                            type="minus-circle"
                            className="mr-2 mt-1"
                            style={{ cursor: 'pointer', color: '#ff4d50' }}
                            onClick={() => removeTax(i)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  ))
                }
              </Row>
              <Row type="flex" justify="end" className="ml-2 mb-2">
                <Col span={14}>
                  <Row type="flex" justify="end">
                    <Col span={12} className="pt-1 ml-3" align="left">
                      <div className="pt-1 pb-1" style={{ cursor: 'pointer' }}>
                        <SpText
                          fontWeight="600"
                          color="#279dfe"
                          onClick={() => setSelectTaxrateModal(true)}
                        >
                          {
                            allSelectedTaxrates.length !== 0 && (
                              <span>{'\u002B'}&nbsp;</span>
                            )
                          }
                          Add Tax Rates
                        </SpText>
                      </div>
                    </Col>
                    <Col span={8} className="pt-1 mr-3" align="right" />
                  </Row>
                </Col>
              </Row>
              {shippingAddress?.street && (
                <Row type="flex" className="mt-2">
                  <Col span={10} />
                  <Col span={14}>
                    <Row type="flex" justify="end" className="ml-1">
                      <Col span={12} className="pt-1 ml-5" align="left">
                        <div className="pt-1 pb-1" style={{ cursor: 'pointer' }}>

                          <SpText
                            fontWeight="600"
                            color="#279dfe"
                            onClick={() => setSelectedShippingFeeModal(true)}
                          >
                            {
                              allSelectedTaxrates.length !== 0 && (
                                <span>{'\u002B'}&nbsp;</span>
                              )
                            }
                            Add Shipping Fee
                          </SpText>
                        </div>
                      </Col>
                      {shippingAmount
                        ? (
                          <>
                            <Col span={6} className="pt-1 mr-3" align="right">
                              <SpText fontWeight="600">
                                {currencyPrefix} {shippingAmount}
                              </SpText>
                            </Col>
                            <Col span={2} className="pt-1" align="right">
                              <Icon
                                type="minus-circle"
                                className="mr-2 mt-1"
                                style={{ cursor: 'pointer', color: '#ff4d50' }}
                                onClick={removeShippingFee}
                              />
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col span={6} className="pt-1 mr-3" align="right" />
                          </>
                        )}
                      <Col span={2} className="pt-1" align="right" />
                    </Row>
                  </Col>
                </Row>
              )}
              <Line opacity="0.3" className="mt-1 mb-1" />
              <Row type="flex" justify="end" className="mr-3">
                <Col className="mt-1 pb-1 mr-3 pr-1">
                  <SpText className="mr-5" fontWeight="500" fontSize="20px">
                    Total Amount
                  </SpText>
                  <SpText fontWeight="600" fontSize="20px">
                    {
                      (getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon)))) < 0 ? (
                        `${currencyPrefix} 0.00`
                      ) : (
                        `${currencyPrefix} ${getAmountWithShippingFee(getFinalAmount(getTotalAmount(getAmountOff(updatedCoupon))))}`
                      )
                    }
                  </SpText>
                </Col>
              </Row>
              <Line />

              {/* --------------------------------------------------------------------PARTIAL PAYMENT------------------------------------------*/}

              <Row className="my-2 mb-3 mt-3">
                <Checkbox
                  checked={partialPayment}
                  onChange={(e) => {
                    setAgreementConfirmation(e.target.checked);
                    if (!e.target.checked) {
                      setPartialPayment(e.target.checked);
                      setGraceDays('');
                      setOverdueInterest('');
                      setInitialAmount(getTenPercentage());
                      setLateFee('');
                    }
                  }}
                >
                  <SpText fontWeight="600">Partial Payment</SpText>
                </Checkbox>
              </Row>
              {partialPayment && (
              <>
                <Row type="flex" className="my-2 mb-3 mt-2" style={{ background: '#eeeeff', padding: '5px' }}>
                  <div className="pt-1 pb-1 pl-1">
                    <SpText className="text-uppercase" fontWeight="600">Payment Terms</SpText>
                  </div>
                </Row>
                <Row type="flex" className="my-2 mb-3 mt-2">
                  <Col span={12}>
                    <div className="pt-1 pb-1"><SpText fontWeight="600">Initial Amount</SpText></div>
                    <div className="pt-1 pb-1 mr-5">
                      <Input
                        name="initialAmount"
                        value={initialAmount}
                        placeholder="0.00"
                        prefix={currencyPrefix}
                        onChange={(e) => {
                          const regex = /^\d*\.?\d*$/;
                          const { value } = e.currentTarget;
                          if (regex.test(value) || value === '') {
                            setInitialAmount(e.currentTarget.value);
                          } else if (!regex.test(value)) {
                            setInitialAmount(0.00);
                          }
                        }}
                        onBlur={e => {
                          if (e.currentTarget.value) {
                            const { value } = e.currentTarget;
                            const rateValue = parseFloat(value);
                            if (Number.isInteger(rateValue)) {
                              setInitialAmount(parseInt(value, 10).toFixed(2));
                            }
                          }
                        }}
                        onKeyPress={e => {
                          const keyCode = e.charCode || e.which;
                          if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <SpError>
                        {simpleValidator.current.message('Initial Payment', initialAmount,
                          `required|minTenPercent:${finalAmountWithCoupon}`)}
                      </SpError>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="pt-1 pb-1"><SpText fontWeight="600">Late Fee (optional)</SpText></div>
                    <div className="pt-1 pb-1 mr-5">
                      <Input
                        name="lateFee"
                        value={lateFee}
                        placeholder="0.00"
                        prefix={currencyPrefix}
                        onChange={(e) => {
                          const regex = /^\d*\.?\d*$/;
                          const { value } = e.currentTarget;
                          if (regex.test(value) || value === '') {
                            setLateFee(e.currentTarget.value);
                          } else if (!regex.test(value)) {
                            setLateFee(0.00);
                          }
                        }}
                        onBlur={e => {
                          if (e.currentTarget.value) {
                            const { value } = e.currentTarget;
                            const rateValue = parseFloat(value);
                            if (Number.isInteger(rateValue)) {
                              setLateFee(parseInt(value, 10).toFixed(2));
                            }
                          }
                        }}
                        onKeyPress={e => {
                          const keyCode = e.charCode || e.which;
                          if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                            e.preventDefault();
                          }
                        }}
                      />
                      <SpError>
                        {simpleValidator.current.message('Late Fee', lateFee,
                          `maxTenPercent:${finalAmountWithCoupon}`)}
                      </SpError>
                    </div>
                  </Col>
                </Row>
                <Row type="flex" className="my-2 mb-3 mt-2">
                  <Col span={12}>
                    <div className="pt-1 pb-1"><SpText fontWeight="600">Interest if Overdue (optional)</SpText></div>
                    <div className="pt-1 pb-1 mr-5">
                      <Input
                        name="overdueInterest"
                        value={overdueInterest}
                        placeholder="Percentage"
                        prefix="%"
                        onChange={(e) => {
                          const regex = /^\d*\.?\d*$/;
                          const { value } = e.currentTarget;
                          if (regex.test(value) || value === '') {
                            setOverdueInterest(e.currentTarget.value);
                          } else if (!regex.test(value)) {
                            setOverdueInterest(0.00);
                          }
                        }}
                        onBlur={e => {
                          if (e.currentTarget.value) {
                            const { value } = e.currentTarget;
                            const rateValue = parseFloat(value);
                            if (Number.isInteger(rateValue)) {
                              setOverdueInterest(parseInt(value, 10).toFixed(2));
                            }
                          }
                        }}
                        onKeyPress={e => {
                          const keyCode = e.charCode || e.which;
                          if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 44) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <SpError>
                      {simpleValidator.current.message('Interest if Overdue', overdueInterest, 'interestIfOverdue')}
                    </SpError>
                  </Col>
                  <Col span={12}>
                    <div className="pt-1 pb-1"><SpText fontWeight="600">Grace Period</SpText></div>
                    <div className="pt-1 pb-1 mr-5">
                      <div className="d-flex align-items-center">
                        <Input
                          style={{ width: '30%' }}
                          name="graceDays"
                          value={graceDays}
                          placeholder="0 to 90"
                          onChange={(e) => setGraceDays(e.target.value)}
                        />
                        <SpText className="ml-2">Days</SpText>
                      </div>
                      <SpError>
                        {simpleValidator.current.message('grace period', graceDays,
                          ((overdueInterest !== '' && overdueInterest !== null) || (lateFee !== '' && lateFee !== null))
                            ? 'required|gracePeriodRange' : 'gracePeriodRange')}
                      </SpError>
                    </div>
                  </Col>
                </Row>
              </>
              )}

              {/* --------------------------------------------------------------------FILE UPLOAD--------------------------------------------- */}
              <Row className="my-2 mb-3 mt-4">
                <Col>
                  <Upload
                    name="avatar"
                    className="avatar-uploader"
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    customRequest={fileUpload}
                    onChange={handleUploadChange}
                    previewFile
                  >
                    {fileName ? preview : uploadButton}
                  </Upload>
                  <SpButton
                    type="primary"
                    shape="round"
                    className="ml-1"
                    onClick={handleViewPdf}
                    disabled={!invoiceFile}// Disable button if invoiceFile is an empty string
                  >
                    View Uploaded File
                  </SpButton>
                </Col>
              </Row>

              <Row className="my-2 mb-3 mt-2">
                <Col>
                  <div className="pt-1 pb-1"><SpText fontWeight="600">Notes</SpText></div>
                  <div className="pt-1 pb-1 mr-5">
                    <Input
                      defaultValue={notes}
                      onChange={(e) => setNotes(e.currentTarget.value)}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="my-2 mb-3 mt-2" style={{ background: '#eeeeff', padding: '5px' }}>
                <Col>
                  <SpText fontWeight="600">{selectedAccount.name}</SpText>
                </Col>
              </Row>
            </SpFormWrapper1>
          </SpWrapper1>
        </Col>
        <Col span={7}>
          <SpWrapper1>
            <SpFormWrapper2>
              <Row type="flex">
                <Icon
                  component={TimelineImg}
                />
                <SpText
                  className="ml-2"
                  fontWeight="600"
                  fontSize="16px"
                  color="#474973"
                  style={{
                    marginTop: '-4px',
                  }}
                >
                  Timeline
                </SpText>
              </Row>
              <Row className="mt-1">
                <img src={PosLine} alt="" />
              </Row>
              <Row>
                <InvoiceTimelineBar
                  paymentTimeline={invoiceDetails.invoiceTimeLines || []}
                  selectedAccount={selectedAccount}
                />
              </Row>
            </SpFormWrapper2>
          </SpWrapper1>
        </Col>
      </Row>
      <Row type="flex" justify="end" gutter={[16, 16]} className="pt-3">
        <Col>
          <SpH5 color="#7f7f7f">{invoiceDetails.gid}</SpH5>
        </Col>
      </Row>
    </Card>
  );
};

// $FlowFixMe
export default EditInvoice;
